import React from 'react'
import { useSelector } from 'react-redux'
import { selectSelectedAdressAsFavorite } from '../../../../store/address/address.selectors'
import { selectCurrentGeoentityAsFavorite } from '../../../../store/geoentity/geoentity.selectors'
import { addOtherFavorite, deleteUserFavorite } from '../../../../store/userAccount/userAccount.actions'
import {
  selectIsUserConnected,
  selectIsUserAccountEnabled,
  selectFavoriteByCurrentPoiId,
  selectFavoriteBySelectedAddress,
  selectUserFavoritesLimitNotReached
} from '../../../../store/userAccount/userAccount.selectors'
import CircledButtonWithLabel, { LogoVariants } from '../../../genericComponents/CircledButtonWithLabel'
import TagActionButton from '../../../genericComponents/TagActionButton'
import { useAction } from '../../../utils/react-redux'
import UserFavoriteError from './UserFavoriteError'
import { TAG_CLICK_USER_FAVORITES_BUTTON } from '../../../../store/analytics/analytics.actionTypes'
import { ACTION } from '../../../analytics/ClickTagsService'
import analyticsConstants from '../../../analytics/analytics.constants'
import { MODAL_IDS } from '../../../../store/ui/ui.constants'
import useModal from '../../../ui/useModal'

const FavoriteButton = ({ favoriteSelector, transformFavoriteSelector }) => {
  const canStillAddFavorite = useSelector(selectUserFavoritesLimitNotReached)
  const isUserAccountAvailable = useSelector(selectIsUserAccountEnabled)
  const isConnected = useSelector(selectIsUserConnected)
  const execAddUserFavorite = useAction(addOtherFavorite)
  const execDeleteUserFavorite = useAction(deleteUserFavorite)
  const { displayModal } = useModal(MODAL_IDS.USER_ACCOUNT_INCENTIVE_POPIN)
  const isFavorite = useSelector(favoriteSelector)
  const poiOrAddressAsFavorite = useSelector(transformFavoriteSelector)
  const icon = isFavorite ? 'favori' : 'coeur'
  const label = isFavorite ? 'useraccount.favorite.delete' : 'useraccount.favorite.add'
  const logoVariant = isFavorite ? LogoVariants.sharpGreenBorder : LogoVariants.sharpDarkGreyBorder
  const shouldDisplayIncentivePopin = isUserAccountAvailable && !isConnected

  const action = () => {
    if (shouldDisplayIncentivePopin) {
      displayModal()
    } else if (isFavorite) {
      execDeleteUserFavorite(isFavorite)
    } else {
      execAddUserFavorite(poiOrAddressAsFavorite)
    }
  }

  const getTagAction = () => {
    const { cardAdd, cardAddIncentive, cardDelete } = analyticsConstants.user.favorites.action

    if (shouldDisplayIncentivePopin) return cardAddIncentive

    return isFavorite ? cardDelete : cardAdd
  }

  if (!isFavorite && !canStillAddFavorite) return null

  return (
    <TagActionButton
      onClick={() => {
        action()
      }}
      deferClick
      type={TAG_CLICK_USER_FAVORITES_BUTTON}
      tagInfo={{
        [ACTION]: getTagAction()
      }}
    >
      <CircledButtonWithLabel svgId={icon} label={label} logoVariant={logoVariant} />

      <UserFavoriteError />
    </TagActionButton>
  )
}

export const AddressFavoriteButton = () => (
  <FavoriteButton
    transformFavoriteSelector={selectSelectedAdressAsFavorite}
    favoriteSelector={selectFavoriteBySelectedAddress}
  />
)

export const GeoentityFavoriteButton = () => (
  <FavoriteButton
    transformFavoriteSelector={selectCurrentGeoentityAsFavorite}
    favoriteSelector={selectFavoriteByCurrentPoiId}
  />
)
